import { Component } from '@angular/core';

@Component({
  selector: 'category-page-skeleton-loader',
  templateUrl: './category-page-skeleton-loader.component.html',
  standalone: false,
})
export class CategoryPageSkeletonLoaderComponent {}
